import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../../client';
import { Match, MatchPreference, MatchState, ProviderOverview, PublicUserProfile, User } from '../../resources';


export type UserMatchesOutput = {
  data: {
    matches: Match[];
    matchPreferences: MatchPreference[];
    users: User[];
    profiles: PublicUserProfile[];
    providerOverviews: ProviderOverview[];
  };
};


export const getUserMatches = (data: { userId: string; states?: MatchState[]; forceMatchCreateIfMissing?: boolean }) =>
  restClient.request<UserMatchesOutput>('/api/v1/matches/get_matches', {
    method: 'POST',
    data: snakecaseKeys(data),
  });
